import * as Companies from "./Companies/Companies";
import * as Contacts from "./Contacts/Contacts";
import * as Locations from "./Locations/Locations";
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["None"] = 0] = "None";
    GeographyType[GeographyType["City"] = 3] = "City";
    GeographyType[GeographyType["Submarket"] = 5] = "Submarket";
    GeographyType[GeographyType["County"] = 10] = "County";
    GeographyType[GeographyType["Subdivision"] = 11] = "Subdivision";
    GeographyType[GeographyType["Country"] = 15] = "Country";
    GeographyType[GeographyType["Region"] = 17] = "Region";
    GeographyType[GeographyType["CoStarProductMarket"] = 132] = "CoStarProductMarket";
    GeographyType[GeographyType["PostalCodeGlobal"] = 142] = "PostalCodeGlobal";
})(GeographyType || (GeographyType = {}));
export var KeywordMatchType;
(function (KeywordMatchType) {
    KeywordMatchType[KeywordMatchType["None"] = 0] = "None";
    KeywordMatchType[KeywordMatchType["Any"] = 1] = "Any";
    KeywordMatchType[KeywordMatchType["All"] = 2] = "All";
})(KeywordMatchType || (KeywordMatchType = {}));
export var AreaUnitOfMeasure;
(function (AreaUnitOfMeasure) {
    AreaUnitOfMeasure[AreaUnitOfMeasure["None"] = 0] = "None";
    AreaUnitOfMeasure[AreaUnitOfMeasure["SquareFoot"] = 1] = "SquareFoot";
    AreaUnitOfMeasure[AreaUnitOfMeasure["SquareMeter"] = 2] = "SquareMeter";
})(AreaUnitOfMeasure || (AreaUnitOfMeasure = {}));
export var PhoneType;
(function (PhoneType) {
    PhoneType[PhoneType["None"] = 0] = "None";
    PhoneType[PhoneType["Office"] = 1] = "Office";
    PhoneType[PhoneType["Mobile"] = 2] = "Mobile";
    PhoneType[PhoneType["Fax"] = 3] = "Fax";
    PhoneType[PhoneType["Home"] = 4] = "Home";
    PhoneType[PhoneType["Pager"] = 5] = "Pager";
    PhoneType[PhoneType["Marketing"] = 6] = "Marketing";
    PhoneType[PhoneType["Other"] = 7] = "Other";
})(PhoneType || (PhoneType = {}));
export var DetailPageType;
(function (DetailPageType) {
    DetailPageType[DetailPageType["None"] = 0] = "None";
    DetailPageType[DetailPageType["Broker"] = 1] = "Broker";
    DetailPageType[DetailPageType["Owner"] = 2] = "Owner";
})(DetailPageType || (DetailPageType = {}));
export var Specialty;
(function (Specialty) {
    Specialty[Specialty["None"] = 0] = "None";
    Specialty[Specialty["AllBrokerage"] = 1] = "AllBrokerage";
    Specialty[Specialty["LandlordRepresentation"] = 2] = "LandlordRepresentation";
    Specialty[Specialty["TenantRepresentation"] = 3] = "TenantRepresentation";
    Specialty[Specialty["Owner"] = 4] = "Owner";
    Specialty[Specialty["Appraisal"] = 5] = "Appraisal";
    Specialty[Specialty["ProfessionalServices"] = 7] = "ProfessionalServices";
    Specialty[Specialty["Lending"] = 8] = "Lending";
    Specialty[Specialty["PropertyManagement"] = 9] = "PropertyManagement";
    Specialty[Specialty["HotelOperation"] = 10] = "HotelOperation";
    Specialty[Specialty["Construction"] = 11] = "Construction";
    Specialty[Specialty["InvestmentBroker"] = 12] = "InvestmentBroker";
    Specialty[Specialty["AssetManagement"] = 13] = "AssetManagement";
})(Specialty || (Specialty = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
    SortDirection[SortDirection["Descending"] = 1] = "Descending";
})(SortDirection || (SortDirection = {}));
export { Companies, Contacts, Locations, };
